// extracted by mini-css-extract-plugin
export default {"cls1":"K9nEVhOhesE52KYNdUId","cls2":"ksSCHsxoKOCtKJciqgE_ K9nEVhOhesE52KYNdUId","isPhone":"azOu31HmeVtk2CvNFaCA"};